import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
import { serviceCategories } from '../data/serviceCategories';
export function ServicesNavItem() {
  const [open, setOpen] = useState(false);
  const [activeSlug, setActiveSlug] = useState(serviceCategories[0].slug);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const isActiveRoute = location.pathname.startsWith('/services');
  const activeCategory = serviceCategories.find(c => c.slug === activeSlug) ?? serviceCategories[0];
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, []);
  return <div ref={wrapperRef} className="relative flex items-center self-center" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} onBlur={e => {
    if (!e.currentTarget.contains(e.relatedTarget as Node)) setOpen(false);
  }} data-id="element-368" data-mp="1d1wf1t5c6rpa">
      <Link to="/services" aria-expanded={open} aria-haspopup="true" onFocus={() => setOpen(true)} className={`inline-flex items-center gap-1.5 whitespace-nowrap text-[12.5px] font-semibold uppercase leading-normal tracking-[0.07em] transition-colors duration-150 ease-out hover:text-white ${isActiveRoute ? 'text-brand-light' : 'text-chalk/70'}`} data-id="element-369" data-mp="23zfouxiwuf7s">
        Services
        <ChevronDownIcon className={`h-3.5 w-3.5 shrink-0 transition-transform duration-150 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-370" data-mp="2rqlc3xr6k9s4" />
      </Link>

      {open && <div className="absolute left-1/2 top-full z-50 w-[min(920px,calc(100vw-48px))] -translate-x-1/2 pt-4" data-id="element-371" data-mp="30sb3x4oz5aqf">
          <div className="grid grid-cols-[minmax(0,280px)_minmax(0,1fr)] overflow-hidden rounded-lg border border-white/10 bg-ink shadow-2xl" data-id="element-372" data-mp="11nb2z6irqylm">
            <ul className="border-r border-white/10 py-3" data-id="element-373" data-mp="wllqrnjt8evy">
              {serviceCategories.map(category => {
            const isActive = category.slug === activeCategory.slug;
            return <li key={category.slug} data-id="element-374" data-mp="1kcr2prmmqn0z">
                    <Link to={`/services/${category.slug}`} onMouseEnter={() => setActiveSlug(category.slug)} onFocus={() => setActiveSlug(category.slug)} className={`flex items-center justify-between gap-3 px-5 py-2 text-[13.5px] font-medium transition-colors duration-150 ease-out ${isActive ? 'bg-charcoal text-white' : 'text-chalk/70 hover:text-white'}`} data-id="element-375" data-mp="1kbpudux00emy">
                      {category.name}
                      <ChevronRightIcon className={`h-4 w-4 shrink-0 ${isActive ? 'text-brand-light' : 'text-chalk/30'}`} aria-hidden="true" data-id="element-376" data-mp="3h021d9sdavtd" />
                    </Link>
                  </li>;
          })}
            </ul>

            <div className="bg-charcoal p-6" data-id="element-377" data-mp="2xb9rnk5363gd">
              <Link to={`/services/${activeCategory.slug}`} className="font-display text-[17px] font-bold tracking-tight text-white hover:text-brand-light" data-id="element-378" data-mp="2xa86gmucw0kx">
                {activeCategory.name}
              </Link>
              <p className="mt-1.5 max-w-[460px] text-[13px] leading-relaxed text-chalk/55" data-id="element-379" data-mp="2tazb5djo3un9">
                {activeCategory.blurb}
              </p>
              <ul className="mt-4 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-380" data-mp="mhneycz8igam">
                {activeCategory.services.map(service => <li key={service.slug} data-id="element-381" data-mp="2nlzddpgnxrq9">
                    <Link to={`/services/${activeCategory.slug}/${service.slug}`} className="block py-1 text-[13px] leading-snug text-chalk/70 transition-colors duration-150 ease-out hover:text-white" data-id="element-382" data-mp="2nkxzzec6ct5d">
                      {service.name}
                    </Link>
                  </li>)}
              </ul>
              <Link to="/services" className="mt-5 inline-block text-[12px] font-bold uppercase tracking-[0.08em] text-brand-light hover:underline" data-id="element-383" data-mp="24ofyw6bfrgwg">
                View all services
              </Link>
            </div>
          </div>
        </div>}
    </div>;
}